import { useEffect, useRef } from 'react'
import { NctsPhase, NctsScope } from '../../../../shared/ncts/types'
import { useServerRequirementsContext } from '../contexts/DeclarationEditorContext'
import useValidateDeclarationQuery from '../components/useValidateDeclarationQuery'
import { ServerValidationResult } from '../../models/types'

interface Params {
  transitOperationId: number | null
  phase: NctsPhase
  isOptIn: boolean
  houseConsignmentId?: number
  consignmentItemId?: number
}

function useScopedServerRequirements(
  scope: NctsScope,
  params: Params,
  opts?: {
    enabled?: boolean
  },
) {
  const {
    transitOperationId,
    phase,
    isOptIn,
    houseConsignmentId,
    consignmentItemId,
  } = params

  const { serverValidationResult, setServerValidationResult } = useServerRequirementsContext(scope)
  const { data: validationResult, isFetching } = useValidateDeclarationQuery(transitOperationId, {
    phase,
    scope,
    isOptIn,
    houseConsignmentId,
    consignmentItemId,
  }, opts)

  const validationResultRef = useRef<ServerValidationResult | null>(null)

  useEffect(() => {
    if (!validationResult) return
    if (validationResultRef.current === validationResult) return

    validationResultRef.current = validationResult

    setServerValidationResult(validationResult)
  }, [validationResult, setServerValidationResult])

  return {
    serverValidationResult,
    isLoading: isFetching,
  }
}

export default useScopedServerRequirements
